import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import React from "react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { getLocaleWithInternationalFallback } from "@swo/shared";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";

export const PressReleaseDateLabel: ReactTFC<{
  dateStr: string;
  locale: SwarovskiOptikLocaleFrontend;
  className?: string;
}> = props => {
  const localeWithInternationalFallback = getLocaleWithInternationalFallback(props.locale);

  const formattedDate = new Date(props.dateStr).toLocaleDateString(localeWithInternationalFallback, {
    month: "long",
    day: "2-digit",
    year: "numeric",
    timeZone: "Europe/Vienna",
  });

  return (
    <span className={props.className} css={[FONTS.SwarovskiFutura300, fontColor.black, fontSize.x2]}>
      {formattedDate}
    </span>
  );
};
